<template>
  <div>
    <div class="container">
      <div class="nav nav-tabs flex-row mb-4">
        <div
          class="nav-item nav-link"
          :class="current == 'PhotoDayTable' ? 'active' : ''"
          @click="current = 'PhotoDayTable'"
        >
          Tour Day
        </div>
        <div
          class="nav-item nav-link"
          :class="current == 'PhotoPackageTable' ? 'active' : ''"
          @click="current = 'PhotoPackageTable'"
        >
          Tour Package
        </div>
        <div
          class="nav-item nav-link"
          :class="current == 'PhotoBannerTable' ? 'active' : ''"
          @click="current = 'PhotoBannerTable'"
        >
          Tour Banner
        </div>
        <div
          class="nav-item nav-link"
          :class="current == 'PhotoGalleryTable' ? 'active' : ''"
          @click="current = 'PhotoGalleryTable'"
        >
          Tour Gallery
        </div>
      </div>
      <transition name="fade">
        <KeepAlive>
          <component :is="current"></component>
        </KeepAlive>
      </transition>
    </div>
  </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";
import PhotoDayTable from "@/components/PhotoDayTable.vue";
import PhotoPackageTable from "@/components/PhotoPackageTable.vue";
import PhotoBannerTable from "@/components/PhotoBannerTable.vue";
import PhotoGalleryTable from "@/components/PhotoGalleryTable.vue";

export default {
  name: "PhotoManagement",

  components: { PhotoDayTable, PhotoPackageTable, PhotoBannerTable, PhotoGalleryTable },

  data() {
    return {
      current: "PhotoDayTable",
    };
  },

  computed: {
    ...mapGetters(["tourDestinations"]),
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchTourDestinations();
      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions(["hideBarLoading", "fetchTourDestinations"]),
  },
};
</script>
  
<style lang="scss" scoped>
.nav-item {
  cursor: pointer;
}
.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-enter-to {
  opacity: 1;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-from {
  opacity: 1;
}
.fade-leave-to {
  opacity: 0;
}
</style>